<template>
  <div class="edit-free-entry disp-scroll" style="height: 350px; padding: 10px; overflow-y: scroll; background-color:white;">
    <div class="contents">
      <p>メッセージ内容</p>
      <article>
        <textarea class="textarea main-message disp-scroll"
          :value="scenarioEdit.mainmessage"
          placeholder="例：お名前を入力してください"
          @input="changeMainmessage($event.target.value)"
          :disabled="scenarioEdit.is_confirm">
        </textarea>
      </article>
      <p>設定項目</p>
      <article class="item-container">
        <template v-if="!isColumnLoading">
          <b-select class="select colomn-name"
            placeholder="設定項目"
            v-model="selectedSettingItem"
            @input="changeParam('colomn_name', selectedSettingItem.name)"
            :disabled="scenarioEdit.is_confirm">
              <option v-for="(s, idx) in seekerSaveList" :key="idx" :value="s">
                {{s.name}}
              </option>
          </b-select>
          <template v-if="inputParameter['colomn_name'] === 'カスタム'">
            <template v-if="filteredCustomColumns.length > 0">
              <b-select class="select colomn-name"
                placeholder="詳細項目"
                :value="inputParameter['custom']"
                @input="changeParam('custom', $event)"
                :disabled="scenarioEdit.is_confirm">
                  <option
                    v-for="(comCol, idx) in filteredCustomColumns"
                    :value="comCol"
                    :key="idx + '-comCol'">
                    {{getCustomName(comCol)}}
                  </option>
              </b-select>
            </template>
            <template v-else>
              <p class="no-col">
                カスタムカラムが存在しません。
                <br>応募者管理画面 > テーブル設定より新しいカラムを設定してください。
              </p>
            </template>
          </template>
        </template>
        <template v-else>
          <span class="mdi mdi-loading mdi-spin"></span>
        </template>
      </article>
      <p>入力形式</p>
      <article class="item-container">
        <b-select
          class="select colomn-name"
          :value="inputParameter['input_type']"
          @input="changeParam('input_type', $event)"
          :disabled="scenarioEdit.is_confirm">
          <option v-for="(s, idx) in inputTypes" :key="idx" :value="s.value">
            {{s.name}}
          </option>
        </b-select>
        <b-select
          class="select colomn-name"
          :value="inputParameter['date_type']"
          @input="changeParam('date_type', $event)"
          v-if="inputParameter['input_type']=='dateone' || inputParameter['input_type']=='datemulti'"
         >
          <option v-for="(s, idx) in inputDateType" :key="idx" :value="s.value">
            {{s.name}}
          </option>
        </b-select>
      </article>
      <div v-if="inputParameter['input_type']=='dateone' || inputParameter['input_type']=='datemulti'">
        <p style="margin-bottom: 8px;">予定時間</p>
        <article class="item-container" style="display: flex;">
          <div style="display: flex; align-items: center;">
            <b-numberinput
              style="width: 100px;"
              size="is-small"
              :editable="false"
              step="1"
              min="0"
              max="23"
              v-model="keep_time_hour"
              @input="changeParam('keep_time_hour', keep_time_hour)"
              controls-position="compact"
              :disabled="scenarioEdit.is_confirm"
            />
            <span style="margin-left: 4px;">時間</span>
          </div>
          <div style="display: flex; align-items: center; margin-left: 16px;">
            <b-numberinput
              style="width: 100px;"
              size="is-small"
              :editable="false"
              step="15"
              min="0"
              max="45"
              v-model="keep_time_minute"
              @input="changeParam('keep_time_minute', keep_time_minute)"
              controls-position="compact"
              :disabled="scenarioEdit.is_confirm"
            />
            <span style="margin-left: 4px;">
              {{'分' + (!keep_time_hour&&!keep_time_minute ? '　(設定無し)' : '')}}
            </span>
          </div>
        </article>
      </div>
      <div v-if="inputParameter['colomn_name']=='生年月日'" style="margin-bottom: 16px;">
          <p style="margin-bottom: 8px;">生年月日の初期値</p>
          <section class="section-3">
            <b-datepicker
              locale="ja-JP"
              v-model="defaultBirth"
              @input="changeParam('default_birth', $event)"
              :focused-date="defaultBirth"
              :mobile-native="false"
              placeholder="生年月日の初期値を設定"
              :open-on-focus="true"
              icon="calendar-today"
            >
          </b-datepicker>
        </section>
      </div>
      <p>応募判定</p>
      <article>
        <b-switch class="apply-flg"
          v-model="inputParameter['apply_flg']"
          @input="changeParam('apply_flg', $event)"
          :disabled="scenarioEdit.is_confirm">
          {{ getApplyFlg(inputParameter['apply_flg']) }}
        </b-switch>
        <div class="annotation">
          <p>(※1) 応募者へはメールをお送りしません。</p>
          <p>(※2) 応募者へ通知をお送りする場合はEメール送付パーツをご利用いただくか、応募フォームパーツをご利用ください。</p>
        </div>
      </article>
      <article>
        <p>任意入力</p>
        <b-switch class="apply-flg"
          v-model="inputParameter['any_flg']"
          @input="changeParam('any_flg', $event)"
          :disabled="scenarioEdit.is_confirm">
        </b-switch>
        <div class="annotation">
          <p>ONにすると未入力でも送信できるようになります。</p>
        </div>
      </article>
      <article>
        <p>デフォルト入力</p>
        <b-switch class="apply-flg"
          v-model="inputParameter['default_flg']"
          @input="changeParam('default_flg', $event)"
          :disabled="scenarioEdit.is_confirm">
        </b-switch>
        <div class="annotation">
          <p>以前自由入力をしている場合に、前回入力がセットされた状態になります。</p>
          <p>※名前、Email、TEL、名前（ふりがな）、住所のみ対応</p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
    },
    seekerSaveList: {
      type: Array
    },
    inputParameter: {
      type: Object
    }
  },
  computed: {
    filteredCustomColumns () {
      let sortedColumns = this.companyColumns.sort((a, b) => {
        if (a.order_type < b.order_type) return -1
        if (a.order_type > b.order_type) return 1
        return 0
      })
      return this.$_.map(
        this.$_.filter(
          sortedColumns,
          ((obj) => {
            return obj.template_type === 0
          })
        ),
        this.$_.property('pk')
      )
    },
    inputTypes () {
      return [].concat(this.inputTypeDefault, 
                      (this.selectedSettingItem && this.selectedSettingItem.date_format ? this.inputTypeDate : []),
                      (this.selectedSettingItem && this.selectedSettingItem.mail_format ? this.inputTypeMail : []),
                      (this.selectedSettingItem && this.selectedSettingItem.half_format ? this.inputTypeHalf : []))
    }
  },
  data () {
    return {
      companyColumns: [],
      isColumnLoading: false,
      inputTypeDefault: [
        {
          name: 'フリー形式',
          value: 'free'
        },
      ],
      inputTypeDate: [
        {
          name: '日付入力形式（単一）',
          value: 'dateone'
        },
        {
          name: '日付入力形式（複数）',
          value: 'datemulti'
        },
      ],
      inputTypeMail: [
        {
          name: 'メールアドレス形式',
          value: 'mail'
        },
      ],
      inputTypeHalf: [
        {
          name: '半角数値形式',
          value: 'half'
        },
      ],
      inputDateType: [
        {
          name: '日付＋時間',
          value: '',
        },
        {
          name: '日付のみ',
          value: 'onlydate'
        },
        // {
        //   name: '時間のみ',
        //   value: 'onlytime'
        // },
      ],
      keep_time_hour: 0,
      keep_time_minute: 0,
      selectedSettingItem: undefined,
      defaultBirth: null,
    }
  },
  created () {
    this.isColumnLoading = true
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
      .then((data) => {
        this.companyColumns = data
        this.isColumnLoading = false
      })
  },
  mounted () {
    if (!this.inputParameter['default_birth']) {
      this.defaultBirth = new Date()
    } else {
      this.defaultBirth = new Date(this.inputParameter['default_birth'])
    }
    if (this.inputParameter['keep_time_hour']) this.keep_time_hour = this.inputParameter['keep_time_hour']
    if (this.inputParameter['keep_time_minute']) this.keep_time_minute = this.inputParameter['keep_time_minute']
    this.selectedSettingItem = this.seekerSaveList.find(elm => elm.name == this.inputParameter['colomn_name'])
  },
  methods: {
    getCustomName (pk) {
      return this.companyColumns[
        this.$_.findIndex(
          this.companyColumns,
          ((obj) => {return obj.pk === pk})
        )
      ].name
    },
    getApplyFlg (flg) {
      if (flg) return '応募者管理画面へデータを格納する'
      else return '応募者管理画面へデータを格納しない'
    },
    changeMainmessage (v) {
      this.$emit('change-mainmessage', v)
    },
    changeParam (key, e) {
      this.$emit('change-param', key, e)

      // 入力形式をフリーに戻す
      if (key=='colomn_name' && this.selectedSettingItem.date_format == false
          && this.inputTypeDate.map(t=>t.value).includes(this.inputParameter['input_type'])) {
        this.changeParam('input_type', 'free')
      }
      if (key=='colomn_name' && this.selectedSettingItem.mail_format == false
          && this.inputTypeMail.map(t=>t.value).includes(this.inputParameter['input_type'])) {
        this.changeParam('input_type', 'free')
      }
      if (key=='colomn_name' && this.selectedSettingItem.half_format == false
          && this.inputTypeHalf.map(t=>t.value).includes(this.inputParameter['input_type'])) {
        this.changeParam('input_type', 'free')
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.edit-free-entry {
  text-align: left;
  .contents {
    height: 500px;
    background-color:white;
  }
  article {
    margin-bottom: 24px;
    text-align: left;
    .main-message {
      margin-top: 8px;
    }
    .colomn-name {
      margin-top: 8px;
    }
    .apply-flg {
      margin-top: 8px;
      font-size: 14px;
    }
  }
  .annotation {
    margin-top: 8px;
    p {
      font-size: 12px;
      text-align: left;
      color: #666;
    }
  }
  .no-col {
    font-size: 12px;
    color: #666;
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditInputParts.vue